/**
 * SimulationBanner — Bannière obligatoire quand le circuit breaker est open.
 * NON DISMISSIBLE — l'admin DOIT savoir qu'il agit sur des données fictives.
 */
import React from 'react';

interface Props {
  onReconnect: () => void;
}

export default function SimulationBanner({ onReconnect }: Props): React.ReactElement {
  return (
    <div
      role="alert"
      className="flex items-center justify-between px-4 py-2 text-sm font-medium"
      style={{
        backgroundColor: 'hsl(var(--simulation-bg))',
        borderBottom: '2px solid hsl(var(--simulation-border))',
        color: 'hsl(var(--simulation-text))',
      }}
    >
      <span>
        ⚠️ <strong>Mode Démo — Backend Indisponible.</strong>{' '}
        Les actions effectuées ici n&apos;affectent pas les données réelles.
      </span>
      <button
        onClick={onReconnect}
        className="ml-4 px-3 py-1 rounded text-xs font-semibold border"
        style={{ borderColor: 'hsl(var(--simulation-border))' }}
      >
        Reconnecter
      </button>
    </div>
  );
}
